import { render, staticRenderFns } from "./ptLog.vue?vue&type=template&id=39cb98c0&"
import script from "./ptLog.vue?vue&type=script&lang=js&"
export * from "./ptLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports